import React from 'react';
import { Reveal } from './Reveal';
import { GlowFrame } from './GlowFrame';
import { SHOW_TRAILER, TRAILER_VIMEO_HASH, TRAILER_VIMEO_ID } from '../config/features';
export function TrailerSection() {
  if (!SHOW_TRAILER) return null;
  return <section id="trailer" aria-label="Trailer" className="bg-ink px-5 py-24 sm:px-8 lg:px-12 lg:py-32" data-id="element-177" data-mp="1plhma4htj8b7">
      <div className="mx-auto max-w-5xl" data-id="element-178" data-mp="1ks57sn6ushw6">
        <Reveal data-id="element-179" data-mp="1ykbqafxhb0ys">
          <p className="mb-3 text-center text-[11px] uppercase tracking-[0.3em] text-ice" data-id="element-180" data-mp="1yjtn0zcefmhd">Watch</p>
          <h2 className="mb-10 text-center font-heading text-4xl uppercase tracking-tight text-led sm:text-5xl" data-id="element-181" data-mp="1ui82crtmi3wm">
            Trailer
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-182" data-mp="23jy2qn5hgd6j">
          <GlowFrame className="relative aspect-video w-full overflow-hidden bg-steel/30" data-id="element-183" data-mp="23joa0rt1zrx5">
            <iframe title="The Doors of Perception — Trailer" src={`https://player.vimeo.com/video/${TRAILER_VIMEO_ID}?h=${TRAILER_VIMEO_HASH}&title=0&byline=0&portrait=0`} className="absolute inset-0 h-full w-full" frameBorder={0} referrerPolicy="strict-origin-when-cross-origin" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen loading="lazy" data-id="element-184" data-mp="e484rni92qcj" />
          </GlowFrame>
        </Reveal>
      </div>
    </section>;
}